<script>
import BrandLogo from '../BrandLogo.vue';
// Footer público — Estilo APPMISIONATE para ELearnSolution
export default {
  components: {
    'brand-logo': BrandLogo,
  },
  name: 'MainFooterView',
}
</script>
<template>
  <footer class="footer-ap">
    <div class="container">
      <div class="footer-grid">
        <div class="footer-brand">
          <div style="display:flex; align-items:center; gap:10px; margin-bottom:12px;">
            <brand-logo variant="light" />
          </div>
          <p>
            Plataforma educativa líder en preparación para exámenes de admisión universitario.
            Más de 3,000 estudiantes aprobados en México.
          </p>
          <div class="social-links">
            <a href="#" class="social-link" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
            <a href="#" class="social-link" aria-label="Twitter"><i class="fab fa-twitter"></i></a>
            <a href="#" class="social-link" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
            <a href="#" class="social-link" aria-label="YouTube"><i class="fab fa-youtube"></i></a>
          </div>
        </div>

        <div class="footer-col">
          <h4>Plataforma</h4>
          <ul>
            <li><a href="/#simuladores">Simuladores</a></li>
            <li><a href="/cursos">Cursos</a></li>
            <li><a href="/#precios">Precios</a></li>
            <li><a href="/noticias">Blog</a></li>
          </ul>
        </div>

        <div class="footer-col">
          <h4>Empresa</h4>
          <ul>
            <li><a href="/acerca">Nosotros</a></li>
            <li><a href="/contacto">Contacto</a></li>
            <li><a href="/acerca">Acerca</a></li>
          </ul>
        </div>

        <div class="footer-col">
          <h4>Legal</h4>
          <ul>
            <li><a href="/terminos-y-condiciones">Términos y Condiciones</a></li>
            <li><a href="/politicas-de-privacidad">Políticas de Privacidad</a></li>
            <li><a href="/soporte">Soporte</a></li>
            <li><a href="/mapa-del-sitio">Mapa del Sitio</a></li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom">
        <p>© 2026 <strong>Appmisiónate</strong>. Todos los Derechos Reservados.</p>
        <p>Hecho con ❤️ en México</p>
      </div>
    </div>
  </footer>
</template>
